(() => {
  function bind(root = document) {
    root.querySelectorAll('[data-am-tabs]').forEach((section) => {
      if (section.dataset.bound === 'true') return;
      section.dataset.bound = 'true';
      const tabs = [...section.querySelectorAll('[role="tab"]')];
      const activate = (tab, focus = false) => {
        tabs.forEach((item) => {
          const active = item === tab;
          item.setAttribute('aria-selected', String(active));
          item.tabIndex = active ? 0 : -1;
          const panel = document.getElementById(item.getAttribute('aria-controls'));
          if (panel) panel.hidden = !active;
        });
        if (focus) tab.focus();
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab));
        tab.addEventListener('keydown', (event) => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          else if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = tabs.length - 1;
          else return;
          event.preventDefault();
          activate(tabs[next], true);
        });
      });
    });
  }
  bind();
  document.addEventListener('shopify:section:load', () => bind());
})();
